export const database = {
  "title": "qorisolutions",
  "walink": "https://wa.me/+51904400186?text=Hola%20Qori%20Solutions,%20quisiera%20más%20información%20por%20favor",
  "walinkproduct": "https://wa.me/+51904400186?text=Hola%20Qori%20Solutions,%20quisiera%20más%20información%20sobre%20",
  "hero": {
    "title": "Bienvenido a Sumaqlink",
    "subtitle": "Crea tu Página Web Profesional con Sumaqlink",
    "description": "Transformamos tus ideas en páginas web atractivas, funcionales y optimizadas para el éxito de tu negocio.",
    "sliders": [
      {
        "id": 1,
        "title": "Licencia de Canva Pro",
        "description": "Aprovecha la oferta de Canva Pro y obtén un descuento especial en tu compra.",
        "image": "/assets/images/products/17.png",
        "backgroundImage": "assets/images/bg1.jpg",
        "buttonLink": "#products"
      },
      {
        "id": 2,
        "title": "Adobe Creative Cloud para toda la familia",
        "description": "Aprovecha la oferta de Adobe Creative Cloud y obtén un descuento especial en tu compra.",
        "image": "/assets/images/products/21.png",
        "backgroundImage": "assets/images/bg1.jpg",
        "buttonLink": "#services"
      }
    ]
  },
  "about": {
    "title": "Qori Solutions",
    "subtitle": "Conoce nuestra historia",
    "description": "En Qori Solutions, somos especialistas en la venta de licencias de software y en brindar asistencia técnica personalizada, tanto de manera remota como presencial. Nuestro objetivo es ofrecer soluciones tecnológicas innovadoras y adaptadas a las necesidades de nuestros clientes, optimizando sus recursos y potenciando su productividad.",
  },
  "services": {
    "title": "Nuestros Servicios",
    "subtitle": "Nuestros servicios",
    "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, consectetur.",
    "buttonText": "Ver Servicios",
    "items": [
      {
        "id": 1,
        "name": "Soporte técnico presencial",
        "description": "Especialistas en la reparación y optimización de equipos informáticos. Contamos con un equipo técnico altamente capacitado y utilizamos componentes de alta calidad para garantizar la satisfacción de nuestros clientes.",
        "price": 10.99,
        "image": "/assets/images/bg_servicio_1.jpg",
        "hoverImage": "https://placehold.in/700x700@2x.png/light",
        "icon": "bi bi-buildings"
      },
      {
        "id": 2,
        "name": "Soporte técnico remoto",
        "description": "Ofrecemos soluciones tecnológicas a distancia, resolviendo de forma rápida y eficiente cualquier inconveniente que presente su equipo desde cualquier lugar.",
        "price": 19.99,
        "image": "/assets/images/bg_servicio_2.jpg",
        "hoverImage": "https://placehold.in/700x700@2x.png/light",
        "icon": "bi bi-buildings"
      },
      {
        "id": 3,
        "name": "Venta de licencias de software originales",
        "description": "Venta, instalación y configuración de software licenciado. Brindamos un servicio integral para que pueda empezar a trabajar de inmediato.",
        "price": 29.99,
        "image": "/assets/images/bg_servicio_3.jpg",
        "hoverImage": "https://placehold.in/700x700@2x.png/light",
        "icon": "bi bi-buildings"
      },
      {
        "id": 2,
        "name": "Actualizaciones de software",
        "description": "Mantenga sus sistemas actualizados y seguros con nuestro servicio de actualización de software. Garantizamos un rendimiento óptimo y la protección de sus datos.",
        "price": 19.99,
        "image": "/assets/images/bg_servicio_4.jpg",
        "hoverImage": "https://placehold.in/700x700@2x.png/light",
        "icon": "bi bi-buildings"
      },
    ]
  },
  "products": {
    "title": "Productos",
    "subtitle": "Conoce nuestros productos",
    "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, consectetur.",
    "items": [
      {
        "id": 1,
        "name": "ESET HOME O ESET SECURITY",
        "description": "ESET HOME o ESET SECURITY es una solución de ciberseguridad integral diseñada para proteger dispositivos contra virus, malware, ransomware y otras amenazas en línea. Ofrece protección en tiempo real con tecnología avanzada de detección, asegurando una experiencia segura para usuarios domésticos y empresas. Incorpora firewall, control parental y herramientas de optimización del sistema para mejorar el rendimiento. Además, cuenta con protección de banca en línea y navegación segura para evitar fraudes y ataques cibernéticos.",
        "price": 35,
        "period": "(Sin duración especificada)",
        "image": "/assets/images/products/8.png",
        "hoverImage": "/assets/images/products/7.png",
        "currency": "S/",
        "offer": false,
        "featured": true,
        "priceFinal": 66.5,
        "priceFinalOffer": 69
      },
      {
        "id": 2,
        "name": "CANVA PRO",
        "description": "Canva Pro es una plataforma de diseño gráfico que permite a los usuarios crear contenido visual de manera profesional y sencilla. Ofrece una amplia variedad de plantillas premium, herramientas avanzadas como la eliminación de fondos, animaciones personalizadas y la posibilidad de trabajar en equipo en proyectos compartidos. Es ideal para diseñadores, emprendedores y creadores de contenido que buscan agilidad y creatividad sin la necesidad de software especializado. Su interfaz intuitiva facilita la producción de imágenes, presentaciones, publicaciones para redes sociales y más.",
        "price": 15,
        "period": "1 AÑO",
        "image": "/assets/images/products/18.png",
        "hoverImage": "/assets/images/products/17.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 28.5,
        "priceFinalOffer": 29
      },
      {
        "id": 3,
        "name": "CANVA PRO EDU",
        "description": "Canva Pro EDU es una versión exclusiva de Canva Pro destinada a docentes y estudiantes, con acceso a todas las funciones premium y herramientas colaborativas. Permite la creación de material educativo interactivo, como infografías, presentaciones, recursos visuales y contenido para proyectos académicos. Facilita el trabajo en equipo mediante funciones de edición en tiempo real y almacenamiento en la nube. Su interfaz accesible permite a estudiantes y educadores desarrollar recursos de aprendizaje visuales con calidad profesional y sin conocimientos avanzados de diseño.",
        "price": 25,
        "period": "PERMANENTE",
        "image": "/assets/images/products/16.png",
        "hoverImage": "/assets/images/products/15.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 47.5,
        "priceFinalOffer": 49
      },
      {
        "id": 4,
        "name": "CAPCUT PRO EDU",
        "description": "CapCut Pro EDU es un editor de video profesional enfocado en el ámbito educativo y creativo, proporcionando herramientas avanzadas de edición, efectos especiales, transiciones y mejoras con inteligencia artificial. Soporta exportaciones en alta resolución, edición multicapa y compatibilidad con diferentes formatos de video. Permite agregar subtítulos automáticos, ajustar la velocidad del video y aplicar filtros cinematográficos. Es ideal para la creación de contenido académico, presentaciones audiovisuales y videos para redes sociales con una calidad profesional sin necesidad de experiencia en edición.",
        "price": 45,
        "period": "1 año",
        "image": "/assets/images/products/36.png",
        "hoverImage": "/assets/images/products/35.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 85.5,
        "priceFinalOffer": 89
      },
      {
        "id": 5,
        "name": "FREEPIK ORIGINAL",
        "description": "Freepik es una plataforma en línea que ofrece un extenso catálogo de recursos gráficos de alta calidad, incluyendo vectores, iconos, ilustraciones, fotos y plantillas PSD. Es una herramienta esencial para diseñadores, creadores de contenido y profesionales del marketing que necesitan elementos visuales atractivos para sus proyectos. Permite descargar y personalizar gráficos para su uso en branding, publicidad, redes sociales y presentaciones. Su biblioteca en constante actualización garantiza acceso a los últimos diseños y tendencias visuales.",
        "price": 50,
        "period": "6 meses",
        "image": "/assets/images/products/40.png",
        "hoverImage": "/assets/images/products/39.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 95.0,
        "priceFinalOffer": 89
      },
      {
        "id": 6,
        "name": "FILMORA 12-13 ORIGINAL",
        "description": "Filmora es un software de edición de video potente e intuitivo que permite a los usuarios crear producciones audiovisuales de alta calidad. Incluye una amplia variedad de efectos visuales, transiciones dinámicas, edición de pantalla verde y compatibilidad con múltiples formatos de video. Ofrece herramientas de edición avanzada como corrección de color, edición de audio y efectos de inteligencia artificial. Su interfaz amigable permite que tanto principiantes como profesionales editen videos con facilidad, optimizando la producción de contenido digital.",
        "price": 55,
        "period": "1 año",
        "image": "/assets/images/products/42.png",
        "hoverImage": "/assets/images/products/41.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 104.5,
        "priceFinalOffer": 99
      },
      {
        "id": 8,
        "name": "TURNITIN",
        "description": "Turnitin es una herramienta líder en detección de plagio utilizada en instituciones académicas y organizaciones profesionales. Analiza documentos comparándolos con una extensa base de datos de contenido en línea, publicaciones científicas y trabajos estudiantiles, garantizando la originalidad de los textos. Su tecnología de coincidencia avanzada ayuda a educadores y revisores a identificar similitudes y fomentar la integridad académica. Además, ofrece retroalimentación automatizada para mejorar la redacción y reducir la posibilidad de plagio en trabajos escritos.",
        "price": 65,
        "period": "6 meses",
        "image": "/assets/images/products/20.png",
        "hoverImage": "/assets/images/products/19.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 123.5,
        "priceFinalOffer": 119
      },
      {
        "id": 9,
        "name": "ADOBE CREATIVE CLOUD PARA TODA LA FAMILIA",
        "description": "Adobe Creative Cloud proporciona acceso a una suite completa de herramientas creativas como Photoshop, Illustrator, Premiere Pro, After Effects e InDesign. Está diseñado para familias y equipos que trabajan en diseño gráfico, edición de video, fotografía y producción multimedia. Ofrece almacenamiento en la nube, integración con dispositivos móviles y actualizaciones constantes de software. Su ecosistema permite la sincronización y colaboración entre usuarios, facilitando la gestión de proyectos creativos en un entorno profesional y doméstico",
        "price": 190,
        "period": "(Sin duración especificada)",
        "image": "/assets/images/products/22.png",
        "hoverImage": "/assets/images/products/21.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 361.0,
        "priceFinalOffer": 359
      },
      {
        "id": 10,
        "name": "AUTODESK",
        "description": "Autodesk es un conjunto de software especializado en diseño, modelado 3D, ingeniería y simulación, utilizado en sectores como arquitectura, manufactura y animación. Incluye herramientas como AutoCAD, Revit, Maya y 3ds Max, que permiten la creación de modelos precisos, planos detallados y animaciones realistas. Su tecnología avanzada ayuda a ingenieros, diseñadores y arquitectos a optimizar flujos de trabajo y mejorar la eficiencia en proyectos de construcción, diseño industrial y producción audiovisual.",
        "price": 50,
        "period": "1 AÑO",
        "image": "/assets/images/products/44.png",
        "hoverImage": "/assets/images/products/43.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 95.0,
        "priceFinalOffer": 89
      },
      {
        "id": 11,
        "name": "POWER BI PRO",
        "description": "Power BI Pro es una plataforma avanzada de análisis de datos y generación de reportes interactivos que permite a las empresas tomar decisiones estratégicas basadas en información visual. Facilita la integración con múltiples fuentes de datos, automatización de procesos y visualización en tiempo real a través de dashboards intuitivos. Es ideal para análisis financiero, gestión de rendimiento y planificación operativa, ofreciendo conectividad con herramientas de Microsoft como Excel y Azure.",
        "price": 135,
        "period": "1 AÑO",
        "image": "/assets/images/products/48.png",
        "hoverImage": "/assets/images/products/47.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 256.5,
        "priceFinalOffer": 259
      },
      {
        "id": 12,
        "name": "KASPERSKY TOTAL SECURITY",
        "description": "Kaspersky Total Security es una solución de seguridad integral que protege dispositivos contra malware, ransomware, spyware y amenazas en línea. Incluye herramientas avanzadas como firewall, control parental, protección de pagos en línea y un sistema de cifrado de datos para resguardar información personal. Su tecnología de inteligencia artificial mejora la detección de amenazas y previene ataques cibernéticos en tiempo real. Además, proporciona protección de redes WiFi y optimización del rendimiento del sistema.",
        "price": 45,
        "period": "1 AÑO",
        "image": "/assets/images/products/54.png",
        "hoverImage": "/assets/images/products/53.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 85.5,
        "priceFinalOffer": 89
      },
      {
        "id": 13,
        "name": "KASPERSKY PLUS",
        "description": "Kaspersky Plus ofrece una protección avanzada contra amenazas digitales con funciones como antivirus, VPN ilimitada, gestor de contraseñas y monitoreo de seguridad en tiempo real. Protege dispositivos contra ataques de phishing, spyware y sitios web maliciosos. Su sistema de protección de banca en línea garantiza la seguridad en transacciones financieras. También incluye herramientas de optimización para mejorar el rendimiento y la velocidad del equipo.",
        "price": 45,
        "period": "1 AÑO",
        "image": "/assets/images/products/56.png",
        "hoverImage": "/assets/images/products/55.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 85.5,
        "priceFinalOffer": 89
      },
      {
        "id": 14,
        "name": "MCAFEE INTERNET SECURITY",
        "description": "McAfee Internet Security es un software de seguridad que protege la navegación web, correos electrónicos y descargas contra virus, malware y ataques de phishing. Incluye firewall avanzado, protección de identidad y un sistema de seguridad para redes WiFi. Ofrece herramientas para optimizar el rendimiento del equipo y mejorar la privacidad del usuario en línea. Su sistema de alertas en tiempo real bloquea amenazas antes de que puedan comprometer la información.",
        "price": 45,
        "period": "1 AÑO",
        "image": "/assets/images/products/58.png",
        "hoverImage": "/assets/images/products/57.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 85.5,
        "priceFinalOffer": 89
      },
      {
        "id": 15,
        "name": "NORTON ANTIVIRUS PLUS",
        "description": "Norton Antivirus Plus proporciona protección contra virus, ransomware, spyware y amenazas en línea con un sistema de detección avanzado. Incorpora firewall, gestor de contraseñas y respaldo en la nube para proteger archivos importantes. Su sistema de inteligencia artificial permite la identificación de amenazas emergentes y garantiza una navegación segura.",
        "price": 45,
        "period": "(Sin duración especificada)",
        "image": "/assets/images/products/66.png",
        "hoverImage": "/assets/images/products/65.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 85.5,
        "priceFinalOffer": 89
      },
      {
        "id": 16,
        "name": "AVG INTERNET SECURITY",
        "description": "AVG Internet Security es una suite de seguridad avanzada diseñada para proteger computadoras y dispositivos contra virus, malware, spyware y ataques de phishing. Su sistema de escaneo en tiempo real identifica y bloquea amenazas antes de que puedan afectar el sistema. Ofrece protección de correo electrónico, análisis de enlaces peligrosos y seguridad en redes WiFi. Además, incorpora un firewall avanzado que previene accesos no autorizados y ataques de hackers. Es ideal tanto para usuarios domésticos como para pequeñas empresas que buscan una protección confiable y eficiente.",
        "price": 45,
        "period": "1 AÑO",
        "image": "/assets/images/products/60.png",
        "hoverImage": "/assets/images/products/59.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 85.5,
        "priceFinalOffer": 89
      },
      {
        "id": 17,
        "name": "AVAST PREMIUN",
        "description": "Avast Premium es una solución de seguridad integral que proporciona defensa avanzada contra virus, ransomware, spyware y amenazas en línea. Cuenta con protección en tiempo real, un potente firewall y seguridad en redes WiFi públicas. Incluye funciones como el modo No \"Molestar\" para optimizar el rendimiento del sistema y un escudo de comportamiento que detecta actividades sospechosas. Además, ofrece protección para compras y banca en línea, asegurando que las transacciones sean seguras y libres de fraudes.",
        "price": 45,
        "period": "1 AÑO",
        "image": "/assets/images/products/72.png",
        "hoverImage": "/assets/images/products/71.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 85.5,
        "priceFinalOffer": 89
      },
      {
        "id": 18,
        "name": "BITDEFENDER ANTIVIRUS PLUS",
        "description": "Bitdefender Antivirus Plus es un software de seguridad de alto rendimiento que protege contra virus, malware, ransomware y amenazas en la web. Utiliza inteligencia artificial y aprendizaje automático para detectar y neutralizar ataques sin afectar el rendimiento del sistema. Incluye un gestor de contraseñas, protección para transacciones bancarias y un escudo contra ataques de phishing. Su escaneo en la nube optimiza la velocidad y garantiza una experiencia de usuario fluida sin comprometer la seguridad.",
        "price": 55,
        "period": "1 AÑO",
        "image": "/assets/images/products/76.png",
        "hoverImage": "/assets/images/products/75.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 104.5,
        "priceFinalOffer": 99
      },
      {
        "id": 19,
        "name": "OFFICE 365 PERSONAL 1TB ONEDRIVE / 50GB CORREO",
        "description": "Office 365 es una suite de productividad basada en la nube que proporciona acceso a aplicaciones esenciales como Word, Excel, PowerPoint y Outlook. Incluye 1TB de almacenamiento en OneDrive para respaldo y sincronización de archivos, además de 50GB de almacenamiento en correo electrónico. Permite el acceso desde múltiples dispositivos y garantiza actualizaciones constantes con las últimas funciones de Microsoft. Es ideal para usuarios individuales que buscan una solución flexible y siempre actualizada.",
        "price": 80,
        "period": "1 AÑO",
        "image": "/assets/images/products/27.png",
        "hoverImage": "/assets/images/products/28.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 152.0,
        "priceFinalOffer": 149
      },
      {
        "id": 20,
        "name": "OFFICE 2021 PROFESIONAL",
        "description": "Office 2021 Profesional es una versión completa de la suite de Microsoft Office que incluye aplicaciones esenciales como Word, Excel, PowerPoint, Outlook, Access y Publisher. Diseñada para empresas y profesionales, ofrece herramientas avanzadas para la gestión de datos, análisis financiero y creación de documentos con calidad profesional. No requiere suscripción, proporcionando acceso permanente a las herramientas más utilizadas en el entorno empresarial.",
        "price": 45,
        "period": "PERMANENTE",
        "image": "/assets/images/products/78.png",
        "hoverImage": "/assets/images/products/77.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 85.5,
        "priceFinalOffer": 89
      },
      {
        "id": 21,
        "name": "OFFICE 2024 PROFESIONAL",
        "description": "Office 2024 Profesional es la versión más reciente de la suite ofimática de Microsoft, con mejoras en rendimiento y nuevas funcionalidades en Word, Excel y PowerPoint. Incorpora inteligencia artificial para optimizar la productividad y facilitar la automatización de tareas. Está diseñada para profesionales y empresas que necesitan una solución completa sin depender de suscripciones. Su compatibilidad con versiones anteriores garantiza una transición fluida sin pérdida de datos.",
        "price": 55,
        "period": "PERMANENTE",
        "image": "/assets/images/products/30.png",
        "hoverImage": "/assets/images/products/29.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 104.5,
        "priceFinalOffer": 99
      },
      {
        "id": 22,
        "name": "OFFICE 2019 BLINDADO",
        "description": "Office 2019 Blindado es una versión optimizada de Microsoft Office 2019 que cuenta con medidas de seguridad reforzadas para prevenir vulnerabilidades. Incluye herramientas como Word, Excel, PowerPoint y Outlook, garantizando estabilidad y fiabilidad en entornos corporativos. Es ideal para empresas que requieren una suite ofimática confiable y segura sin necesidad de actualizaciones frecuentes.",
        "price": 90,
        "period": "(Sin duración especificada)",
        "image": "/assets/images/products/84.png",
        "hoverImage": "/assets/images/products/83.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 171.0,
        "priceFinalOffer": 169
      },
      {
        "id": 23,
        "name": "WINDOWS 10/11 PRO RETAIL",
        "description": "Windows 10/11 Pro Retail es un sistema operativo diseñado para profesionales y empresas, con funciones avanzadas como BitLocker para cifrado de datos, acceso remoto a través de Remote Desktop y compatibilidad con entornos empresariales. Ofrece mejoras en seguridad, optimización del rendimiento y soporte para aplicaciones de productividad. Se puede instalar en cualquier equipo sin estar vinculado a un hardware específico.",
        "price": 35,
        "period": "PERMANENTE",
        "image": "/assets/images/products/4.png",
        "hoverImage": "/assets/images/products/3.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 66.5,
        "priceFinalOffer": 69
      },
      {
        "id": 24,
        "name": "WINDOWS 10/11 OEM PRO",
        "description": "Windows 10/11 OEM Pro es una versión del sistema operativo destinada a fabricantes de equipos y usuarios avanzados. Incluye todas las funciones de la versión Pro, como seguridad avanzada, soporte para redes empresariales y herramientas de gestión remota. Está vinculada al hardware en el que se instala por primera vez, lo que la hace ideal para equipos nuevos o actualizaciones específicas.",
        "price": 50,
        "period": "REACTIBABLE",
        "image": "/assets/images/products/2.png",
        "hoverImage": "/assets/images/products/1.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 95.0,
        "priceFinalOffer": 89
      },
      {
        "id": 25,
        "name": "VISIO PRO 2016",
        "description": "Visio Pro 2016 es un software de diagramación profesional que permite crear mapas conceptuales, diagramas de flujo, planos arquitectónicos y representaciones visuales detalladas. Incluye herramientas avanzadas para modelado de procesos y compatibilidad con múltiples formatos de archivo. Es ideal para ingenieros, arquitectos y analistas de negocios que requieren representaciones gráficas precisas.",
        "price": 35,
        "period": "PERMANENTE NO REINSTALABLE",
        "image": "/assets/images/products/92.png",
        "hoverImage": "/assets/images/products/91.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 66.5,
        "priceFinalOffer": 69
      },
      {
        "id": 26,
        "name": "PROJECT PRO 2016",
        "description": "Project Pro 2016 es una herramienta de gestión de proyectos que facilita la planificación, asignación de recursos y control del progreso en tiempo real. Incluye diagramas de Gantt, reportes avanzados y herramientas para seguimiento de costos y plazos. Es ideal para gestores de proyectos que necesitan organizar tareas de manera eficiente y visualizar cronogramas de ejecución.",
        "price": 35,
        "period": "PERMANENTE NO REINSTALABLE",
        "image": "/assets/images/products/94.png",
        "hoverImage": "/assets/images/products/93.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 66.5,
        "priceFinalOffer": 69
      },
      {
        "id": 27,
        "name": "VISIO PRO 2019",
        "description": "Visio Pro 2019 es una versión mejorada de la herramienta de diagramación de Microsoft que permite crear esquemas, diagramas técnicos y flujos de trabajo con mayor precisión. Ofrece plantillas actualizadas, compatibilidad con Microsoft 365 y opciones avanzadas de colaboración en línea. Es ideal para equipos que necesitan representar procesos de forma clara y profesional.",
        "price": 35,
        "period": "PERMANENTE NO REINSTALABLE",
        "image": "/assets/images/products/90.png",
        "hoverImage": "/assets/images/products/89.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 66.5,
        "priceFinalOffer": 69
      },
      {
        "id": 28,
        "name": "PROJECT PRO 2019",
        "description": "Project Pro 2019 es un software avanzado de planificación de proyectos que permite administrar tareas, recursos y presupuestos de manera eficiente. Incorpora herramientas de seguimiento del progreso y generación de reportes detallados. Su integración con Microsoft 365 permite la colaboración en línea y el acceso a proyectos desde cualquier dispositivo.",
        "price": 35,
        "period": "PERMANENTE NO REINSTALABLE",
        "image": "/assets/images/products/96.png",
        "hoverImage": "/assets/images/products/95.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 66.5,
        "priceFinalOffer": 69
      },
      {
        "id": 29,
        "name": "VISIO PRO 2021",
        "description": "Visio Pro 2021 es la versión más reciente de la herramienta de diagramación de Microsoft, con mejoras en automatización de procesos, compatibilidad con bases de datos y conectividad en la nube. Permite la creación de representaciones gráficas complejas con una interfaz intuitiva y opciones de colaboración en tiempo real. Es ideal para ingenieros, diseñadores y analistas de datos.",
        "price": 35,
        "period": "PERMANENTE NO REINSTALABLE",
        "image": "/assets/images/products/88.png",
        "hoverImage": "/assets/images/products/87.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 66.5,
        "priceFinalOffer": 69
      },
      {
        "id": 30,
        "name": "PROJECT PRO 2021",
        "description": "Project Pro 2021 es la última versión del software de gestión de proyectos de Microsoft, diseñada para optimizar la planificación, ejecución y monitoreo de tareas. Incluye nuevas herramientas de automatización, integración con Microsoft Teams y reportes personalizables. Su enfoque en eficiencia y productividad lo hace ideal para proyectos empresariales y planificación estratégica.",
        "price": 35,
        "period": "PERMANENTE NO REINSTALABLE",
        "image": "/assets/images/products/98.png",
        "hoverImage": "/assets/images/products/97.png",
        "currency": "S/",
        "offer": false,
        "featured": false,
        "priceFinal": 66.5,
        "priceFinalOffer": 69
      }
    ]
  },
  "ads": {
    "title": "Oferta de la semana",
    "subtitle": "Ahorra un 20% al gastar más de $125",
    "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, consectetur.",
    "backgroundImage": "https://static.wixstatic.com/media/c837a6_678a6092e54043ed9b4081c2463ed428~mv2.jpg/v1/fill/w_1689,h_458,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/c837a6_678a6092e54043ed9b4081c2463ed428~mv2.jpg",
    "buttonText": "Ver Ofertas"
  },
  "contact": {
    "title": "Contacto",
    "subtitle": "Comunicate para cualquier ayuda requerida",
    "description": "Estamos aquí para ayudarte con cualquier consulta o solicitud. Completa el formulario y nos pondremos en contacto contigo lo antes posible.",
    "form": {
      "name": "Nombre",
      "email": "Correo",
      "subject": "Asunto",
      "message": "Mensaje",
      "submit": "Enviar"
    }
  },
  "footer": {
    "address": "Perú | Lima - Ayacucho",
    "phone": "989989989",
    "email": "VZ2b3@example.com",
    "socials": [
      {
        "id": 1,
        "name": "Facebook",
        "icon": "bi bi-facebook",
        "link": "https://www.facebook.com/qorisolutions"
      },
      {
        "id": 2,
        "name": "Instagram",
        "icon": "bi bi-instagram",
        "link": "https://www.instagram.com/qorisolutions/"
      },
      {
        "id": 3,
        "name": "Tiktok",
        "icon": "bi bi-tiktok",
        "link": "https://www.tiktok.com/@qorisolutions"
      }
    ]
  }
}